export default "__VITE_ASSET__C4Lv$diK__"